import React from 'react';
import { BridgePage } from './components/BridgePage';
export function App() {
  return <BridgePage data-id="element-0" data-mp="35ckbgah8v8kk" />;
}